import { CalendarDays, Landmark } from "lucide-react";

type AccountingLandingHeaderProps = {
  selectedDate: string;
};

export default function AccountingLandingHeader({
  selectedDate,
}: AccountingLandingHeaderProps) {
  return (
    <div className="mb-6">
      <div className="flex items-center gap-3 mb-2">
        <div className="w-11 h-11 rounded-[14px] bg-[#EEF3FF] flex items-center justify-center">
          <Landmark className="w-5 h-5 text-[#1A5EF9]" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-[#1A2B4A]">
            Daily Accounting
          </h1>
          <p className="text-sm text-[#7D8998]">
            Confirm your opening balance to start today's session
          </p>
        </div>
      </div>

      <div className="mt-4 inline-flex items-center gap-2 rounded-[12px] border border-[#E5ECF8] bg-[#F5F8FD] px-4 py-2.5">
        <CalendarDays className="h-4 w-4 text-[#1A5EF9]" />
        <span className="text-sm font-medium text-[#23324D]">
          {selectedDate}
        </span>
      </div>
    </div>
  );
}
